import { ACCOUNT_SETTINGS_ACTION_TYPE } from "./account-settings.action";

export const ACCOUNT_SETTINGS_MESSAGE_CONTEXT = {
	changePassword: ACCOUNT_SETTINGS_ACTION_TYPE.changePassword,
};
